import { instance } from "libs/api";

import { ApiRoutesBanners } from "../../constants";
import { CreateBannerBody, CreateBannerResponse } from "./createBanner.types";

export const requestCreateBanner = async (
  body: CreateBannerBody
): Promise<CreateBannerResponse> => {
  return await instance.post(ApiRoutesBanners.Banners, body);
};
